import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';

function useGetTenant() {
  const selectedTenetFromLocalstorage = localStorage.getItem('selectedTenet') || '';
  if (!selectedTenetFromLocalstorage) {
    return '';
  }
  return JSON.parse(selectedTenetFromLocalstorage);
}

export default useGetTenant;
